import React from "react";
import styled, { keyframes } from "styled-components";
import Toast from "react-bootstrap/Toast";
import { Toast as ToastType } from "../../types/toastTypes";
import {
  compassLightGreen,
  compassBordeaux,
  compassLightBlue,
  greyText,
  compassYellow,
  lightGreenBackground,
  compassLightRed,
} from "../../styles";
import { ElementContainer, RowContainer } from "../containers/styledComponents";
import { Icon, IconContainer } from "./styledComponents";
import notification from "../../assets/svg/notification.svg";
import { CompassParagraph } from "../common/styledComponents";

const fadeInAndSlideDown = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;
/* eslint-disable */
const AnimatedToast = styled(Toast)<{ border: string; show: boolean }>`
  animation: ${({ show }) => (show ? fadeInAndSlideDown : fadeOut)} 0.5s
    ease-out;
  border: 1px solid ${({ border }) => border};
  font-family: "Apercu";
  background-color: white;
`;
/* eslint-enable */

const ToastHeader = styled(Toast.Header)`
  border: none;
  padding: 0 8px;
`;

const ToastBody = styled(Toast.Body)`
  padding: 12px 10px;
  padding-top: 0px;
  border: none;
`;

export const CustomToast: React.FC<ToastType> = ({
  //eslint-disable-next-line
  message,
  type,
  onClose,
}) => {
  const toastTypes = {
    success: {
      border: compassLightGreen,
      title: "success",
      iconBg: lightGreenBackground,
    },
    error: { border: compassBordeaux, title: "error", iconBg: compassLightRed },
    info: { border: compassLightBlue, title: "info", iconBg: "#e1e1e1" },
    warning: {
      border: compassYellow,
      title: "warning",
      iconBg: "#e1e1e1",
    },
  };

  const { border, title, iconBg } = toastTypes[type];

  return (
    <AnimatedToast
      show={true}
      onClose={onClose}
      delay={8000}
      autohide
      border={border}
      className={`${border} d-inline-block m-1`}
    >
      <ToastHeader closeButton={false}>
        <RowContainer ai={"top"}>
          <ElementContainer ai={"top"}>
            <IconContainer p={4} m={1} size={30} bg={iconBg}>
              <Icon src={notification} />
            </IconContainer>
            <CompassParagraph
              className="me-auto"
              fontSize={14}
              color={greyText}
              bold={true}
              ml={10}
            >
              {"Notification: "}
              {title}
            </CompassParagraph>
          </ElementContainer>
          <small onClick={onClose} style={{ cursor: "pointer" }}>
            Close
          </small>
        </RowContainer>
      </ToastHeader>
      <ToastBody>
        <CompassParagraph color="#525252" ml={40}>
          {message}
        </CompassParagraph>
      </ToastBody>
    </AnimatedToast>
  );
};
